var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-2022-Compact-listing-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ruka-Ski-inn-kohdelistaus-mobile-A-Copy-2",
    transform: "translate(-94.000000, -829.000000)",
    fill: "#222233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(18.000000, 818.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0:-Base-/-Icon/24px/tune",
    transform: "translate(76.500000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.42108547e-14,14.0000001 L-1.42108547e-14,16.0000001 L7,16.0000001 L7,14.0000001 L-1.42108547e-14,14.0000001 M-1.42108547e-14,2.00000001 L-1.42108547e-14,4.00000001 L11.6666667,4.00000001 L11.6666667,2.00000001 L-1.42108547e-14,2.00000001 M11.6666667,18.0000001 L11.6666667,16.0000001 L21.0000001,16.0000001 L21.0000001,14.0000001 L11.6666667,14.0000001 L11.6666667,12.0000001 L9.33333337,12.0000001 L9.33333337,18.0000001 L11.6666667,18.0000001 M4.66666669,6.00000003 L4.66666669,8.00000003 L-1.42108547e-14,8.00000003 L-1.42108547e-14,10 L4.66666669,10 L4.66666669,12 L7,12 L7,6.00000003 L4.66666669,6.00000003 M21.0000001,10 L21.0000001,8.00000003 L9.33333337,8.00000003 L9.33333337,10 L21.0000001,10 M14.0000001,6 L16.3333334,6 L16.3333334,4 L21.0000001,4 L21.0000001,2 L16.3333334,2 L16.3333334,1.77635684e-15 L14.0000001,1.77635684e-15 L14.0000001,6 Z",
    id: "Icon/24px/tune"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c59724a35478bf5c2e84074e0e0317bc.svg";
export { ForwardRef as ReactComponent };